var codeblock_default = {
  "blockStyleSpacing": "Rc9t7",
  "codeBlock": "XTvUi Rc9t7",
  "renderedInTable": "y6GdS"
};
export {
  codeblock_default as default
};
//# sourceMappingURL=codeblock-scss.js.map
